import { CssBaseline } from "@mui/material";
import { useCreateOnboarding, useGetOnboarding } from "controller";
import { Provider, useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import { OnboardingModal } from "../onboarding";
import { useCurrentStep } from "./hooks";
import {
  OnboardingChannels,
  OnboardingCompanyProfile,
  OnboardingCustomers,
  OnboardingIntegrations,
  OnboardingReady,
  OnboardingSampleData,
  OnboardingTeam,
  steps,
} from "./steps";
import { OnboardingStepKey, onboardingStore, setCurrentStepFn } from "./store";

export const Onboarding = () => {
  return (
    <Provider store={onboardingStore}>
      <CssBaseline />
      <OnboardingPage />
    </Provider>
  );
};

const OnboardingPage = () => {
  const { data: onboardingData, isLoading: isOnboardingDataLoading } =
    useGetOnboarding();
  const setCurrentStep = useSetAtom(setCurrentStepFn);

  const getIsStepCompleted = (stepKey: string) => {
    const stepData = onboardingData?.setupSequence?.find(
      (item: {
        stage_number: number;
        stage_key: string;
        is_completed: boolean;
      }) => item?.stage_key === stepKey,
    );
    return stepData?.is_completed || false;
  };

  const initializedRef = useRef(false);
  useEffect(() => {
    if (initializedRef.current) return; // Prevent re-running after first time
    if (onboardingData === undefined) return; // Wait until API data is available
    const alreadyVisitedStepKeys =
      onboardingData?.setupSequence?.map((item: any) => item.stage_key) || [];
    const firstNeverVisitedStep =
      steps.find((step) => !alreadyVisitedStepKeys.includes(step.key)) ||
      steps[0];
    setCurrentStep(firstNeverVisitedStep);
    initializedRef.current = true; // Mark as initialized
  }, [onboardingData]);

  const {
    mutateAsync: createOnboarding,
    isLoading: isCreateOnboardingLoading,
  } = useCreateOnboarding();
  // const {
  //   mutateAsync: updateOnboarding,
  //   isLoading: isUpdateOnboardingLoading,
  // } = useUpdateOnboarding();

  const { currentStep } = useCurrentStep();
  // const currentStepDataFromDB = onboardingData?.setupSequence?.find(
  //   (step: {
  //     stage_number: number;
  //     stage_key: OnboardingStepKey;
  //     is_completed: boolean;
  //   }) => step.stage_key === currentStep.key
  // );
  // const onboardingApi = currentStepDataFromDB
  //   ? updateOnboarding
  //   : createOnboarding;
  const onboardingApi = createOnboarding;
  // const isOnboardingApiLoading = currentStepDataFromDB
  //   ? isUpdateOnboardingLoading
  //   : isCreateOnboardingLoading;
  const isOnboardingApiLoading = isCreateOnboardingLoading;

  const currentStepKey = currentStep.key;

  // (alias) type OnboardingStepKey = "team" | "company-profile" | "integrations" | "customers" | "sample-data" | "channels" | "billing-settings" | "ready"

  const getOnboardingComponent = () => {
    switch (currentStepKey) {
      case "team":
        return (
          <OnboardingTeam
            onboardingData={onboardingData}
            isOnboardingDataLoading={isOnboardingDataLoading}
            onboardingApi={onboardingApi}
            isOnboardingApiLoading={isOnboardingApiLoading}
            isStepCompleted={getIsStepCompleted("team")}
          />
        );
      case "company-profile":
        return (
          <OnboardingCompanyProfile
            onboardingData={onboardingData}
            isOnboardingDataLoading={isOnboardingDataLoading}
            onboardingApi={onboardingApi}
            isOnboardingApiLoading={isOnboardingApiLoading}
            isStepCompleted={getIsStepCompleted("company-profile")}
          />
        );
      case "integrations":
        return (
          <OnboardingIntegrations
            onboardingData={onboardingData}
            isOnboardingDataLoading={isOnboardingDataLoading}
            onboardingApi={onboardingApi}
            isOnboardingApiLoading={isOnboardingApiLoading}
            isStepCompleted={getIsStepCompleted("integrations")}
          />
        );
      case "customers":
        return (
          <OnboardingCustomers
            onboardingData={onboardingData}
            isOnboardingDataLoading={isOnboardingDataLoading}
            onboardingApi={onboardingApi}
            isOnboardingApiLoading={isOnboardingApiLoading}
            isStepCompleted={getIsStepCompleted("customers")}
          />
        );
      case "sample-data":
        return (
          <OnboardingSampleData
            onboardingData={onboardingData}
            isOnboardingDataLoading={isOnboardingDataLoading}
            onboardingApi={onboardingApi}
            isOnboardingApiLoading={isOnboardingApiLoading}
            isStepCompleted={getIsStepCompleted("sample-data")}
          />
        );
      case "channels":
        return (
          <OnboardingChannels
            onboardingData={onboardingData}
            isOnboardingDataLoading={isOnboardingDataLoading}
            onboardingApi={onboardingApi}
            isOnboardingApiLoading={isOnboardingApiLoading}
            isStepCompleted={getIsStepCompleted("channels")}
          />
        );
      case "ready":
        return <OnboardingReady />;
      default:
        return <></>;
    }
  };

  // const isSourceFormCompleted = onboardingData?.setupSequence?.find(
  //   (item: { stage_key?: string; is_completed?: boolean }) =>
  //     item?.stage_key === "source-form",
  // )?.is_completed;

  return (
    <>
      {/* {isSourceFormCompleted ? getOnboardingComponent() : null} */}
      <OnboardingModal />
    </>
  );
};
